export default "__VITE_ASSET__Cq_HK$yb__"